import { render } from "./OrganizationUnits.vue?vue&type=template&id=7783f0c8&scoped=true"
import script from "./OrganizationUnits.vue?vue&type=script&lang=js"
export * from "./OrganizationUnits.vue?vue&type=script&lang=js"

import "./OrganizationUnits.vue?vue&type=style&index=0&id=7783f0c8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7783f0c8"]])

export default __exports__